import { createSlice } from '@reduxjs/toolkit';
import {
    fetchBranches,
    addBranch,
    getBranchById,
    editBranch,
    deleteBranch
}  from '../actions/branch';

import {
    fetchWarehouses,
    editWarehouse,
    addWarehouse,
    checkWarehouseExists,
    deleteWarehouse
} from '../actions/warehouse';

import {
    fetchContainers,
    editContainer,
    addContainer,
    checkContainerExists,
    deleteContainer
} from '../actions/container';

export const branchSlice = createSlice({
    name: 'branch',
    initialState: {
        warehouseExists: false,
        containerExists: false,
        loading: false,
        addedBranch: '',
        data: [],
        current: '',
        branchToEdit: '',
        editedBranch: '',
        branchToEditLoading: false,
        warehouse: [],
        container: [],
        editedWarehouse: '',
        editedContainer: '',
        error: null,
        deletedWarehouse: '',
        deletedContainer: ''
    },
    reducers: {
        setCurrentBranch: (state, action) => {
            state.current = action.payload;
        },
        resetBranch: (state) => {
            state.current = '';
            state.data = [];
        }
    },
    extraReducers:(builder) => {
        builder
         // ADD BRANCH
         .addCase(addBranch.pending,(state) => { state.loading = true })
         .addCase(addBranch.fulfilled,(state, action) => { 
             state.loading = false;
             state.addedBranch = action.payload
         })
         .addCase(addBranch.rejected, (state) => { state.loading = false  })
        // FETCH BRANCHES
        .addCase(fetchBranches.pending,(state) => { state.loading = true })
        .addCase(fetchBranches.fulfilled,(state, action) => { 
            state.loading = false;
            state.data = action.payload

            // Set current branch to the first one in the list if available
            if (action.payload.length > 0) {
                state.current = action.payload[0]._id;
            }
        })
        .addCase(fetchBranches.rejected, (state) => { state.loading = false  })
        // GET BRANCH BY ID
        .addCase(getBranchById.pending,(state) => { state.branchToEditLoading = true })
        .addCase(getBranchById.fulfilled,(state, action) => { 
            state.branchToEditLoading = false;
            state.branchToEdit = action.payload;
        })
        .addCase(getBranchById.rejected, (state) => {state.branchToEditLoading = false })
        // EDIT BRANCH
        .addCase(editBranch.pending,(state) => { state.branchToEditLoading = true })
        .addCase(editBranch.fulfilled,(state, action) => { 
            state.branchToEditLoading = false;
            state.editedBranch = action.payload;
        })
        .addCase(editBranch.rejected, (state) => {state.branchToEditLoading = false })
        // DELETE BRANCH
        .addCase(deleteBranch.pending,(state) => { state.loading = true })
        .addCase(deleteBranch.fulfilled,(state) => { 
            state.loading = false;
        })
        .addCase(deleteBranch.rejected, (state) => {state.loading = false })
        // FETCH WAREHOUSES
        .addCase(fetchWarehouses.pending,(state) => { state.loading = true })
        .addCase(fetchWarehouses.fulfilled,(state, action) => { 
            state.loading = false;
            state.warehouse = action.payload
        })
        .addCase(fetchWarehouses.rejected, (state) => { state.loading = false  })
         // EDIT WAREHOUSE
         .addCase(editWarehouse.pending,(state) => { state.loading = true })
         .addCase(editWarehouse.fulfilled,(state, action) => { 
             state.loading = false;
             state.editedWarehouse = action.payload
         })
         .addCase(editWarehouse.rejected, (state) => { state.loading = false  })
        // ADD WAREHOUSE
        .addCase(addWarehouse.pending,(state) => { state.loading = true })
        .addCase(addWarehouse.fulfilled,(state, action) => { 
            state.loading = false;
            state.editedWarehouse = action.payload
        })
        .addCase(addWarehouse.rejected, (state) => { state.loading = false  })
        // CHECK WAREHOUSE EXISTS
        .addCase(checkWarehouseExists.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(checkWarehouseExists.fulfilled, (state, action) => {
            state.loading = false;
            state.warehouseExists = action.payload;
        })
        .addCase(checkWarehouseExists.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // DELETE WAREHOUSE
        .addCase(deleteWarehouse.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(deleteWarehouse.fulfilled, (state, action) => {
            state.loading = false;
            state.deletedWarehouse = action.payload;
        })
        .addCase(deleteWarehouse.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // FETCH CONTAINERS
        .addCase(fetchContainers.pending,(state) => { state.loading = true })
        .addCase(fetchContainers.fulfilled,(state, action) => { 
            state.loading = false;
            state.container = action.payload
        })
        .addCase(fetchContainers.rejected, (state) => { state.loading = false  })
         // EDIT CONTAINER
         .addCase(editContainer.pending,(state) => { state.loading = true })
         .addCase(editContainer.fulfilled,(state, action) => { 
             state.loading = false;
             state.editedContainer = action.payload
         })
         .addCase(editContainer.rejected, (state) => { state.loading = false  })
        // ADD CONTAINER
        .addCase(addContainer.pending,(state) => { state.loading = true })
        .addCase(addContainer.fulfilled,(state, action) => { 
            state.loading = false;
            state.editedContainer = action.payload
        })
        .addCase(addContainer.rejected, (state) => { state.loading = false  })
        // CHECK CONTAINER EXISTS
        .addCase(checkContainerExists.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(checkContainerExists.fulfilled, (state, action) => {
            state.loading = false;
            state.containerExists = action.payload;
        })
        .addCase(checkContainerExists.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // DELETE WAREHOUSE
        .addCase(deleteContainer.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(deleteContainer.fulfilled, (state, action) => {
            state.loading = false;
            state.deletedContainer = action.payload;
        })
        .addCase(deleteContainer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });       
    }
});


export const { setCurrentBranch, resetBranch } = branchSlice.actions;
export default branchSlice.reducer; 
